/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { closest } from '@/js/utils/css'
import { findOne } from '@/js/utils/dom'

/**
 * Wire add/remove controls for Symfony form collections.
 *
 * @type {Listener}
 */
export default {
    selector: '.add-collection,.remove-collection',
    connect(element, { app }) {
        /** @type {CollectionManager} */
        const collectionManager = app.get('collectionManager')

        const onClick = (e) => {
            e.preventDefault()

            if (element.classList.contains('remove-collection')) {
                e.stopPropagation()
                collectionManager.removeElement(element)
                return
            }

            const wrapper = closest(element, '.collection-wrapper')
            const collection = findOne('.collection', wrapper)
            collectionManager.addElement(collection)
        }

        element.addEventListener('click', onClick)

        return () => element.removeEventListener('click', onClick)
    },
}
